import { createArrayUpdater, createPropertyUpdater, ID, idDef, MapAction, SetAction, SetDelta } from "@kosmod/kit"
import { def, s } from "@kosmod/pancake/shapes";
import { GameID, Player, PlayerID, SecretID } from "@kosmod/sesame";
import { SceneID } from "@kosmod/theatre";

export type RoomID = ID<"room", true>;
export const RoomID = def<RoomID>()(idDef);

export type Room = {
  id: RoomID,
  game: GameID,

  name: string,

  scene: SceneID,

  players: PlayerID[]
}
export const Room = s.ref<Room>()(s.o({
  id: RoomID,
  game: GameID,

  name: s.str,

  scene: SceneID,
  players: s.a(PlayerID)
}))

export type RoomInternal = {
  id: RoomID,
  game: GameID,

  secretCode: SecretID,
}
export const RoomInternal = s.o({
  id: RoomID,
  game: GameID,
  secretCode: SecretID,
})

export type RoomAction =
  | { type: 'rename', name: string }
  | { type: 'set-scene', sceneId: SceneID }
  | { type: 'players', a: SetAction<PlayerID> }

export const updateRoom = (room: Room, action: RoomAction): Room => {
  switch (action.type) {
    case 'rename':
      return { ...room, name: action.name };
    case 'set-scene':
      return { ...room, scene: action.sceneId };
    case 'players':
      // TODO
      return room;
  }
}